import Reveal from "@/components/base/Reveal";
import { timeline } from "@/mocks/home";

export default function Timeline() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-accent-700">
              <i className="ri-history-line" aria-hidden="true"></i>
              Nossa trajetória
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              Experiência que acompanha a evolução da internet.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Desde 2007, a NXHOST atua no segmento de tecnologia e infraestrutura digital,
              acompanhando a evolução das necessidades de empresas e projetos online.
            </p>
          </div>
        </Reveal>

        <div className="relative mt-14">
          <div className="absolute left-1/2 top-0 hidden h-full w-px -translate-x-1/2 bg-background-200 lg:block"></div>
          <div className="flex flex-col gap-8 lg:gap-12">
            {timeline.map((step, index) => (
              <Reveal key={step.title} delay={index * 80}>
                <div
                  className={`relative lg:flex lg:items-center lg:gap-10 ${
                    index % 2 === 1 ? "lg:flex-row-reverse" : ""
                  }`}
                >
                  <div className="lg:w-1/2">
                    <div
                      className={`rounded-xl border border-background-200 bg-background-50 p-6 ${
                        index % 2 === 1 ? "lg:ml-10" : "lg:mr-10 lg:text-right"
                      }`}
                    >
                      <span className="inline-flex items-center gap-2 rounded-full bg-primary-100/70 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-primary-700">
                        <i className="ri-calendar-line" aria-hidden="true"></i>
                        {step.year}
                      </span>
                      <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">
                        {step.title}
                      </h3>
                      <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                        {step.description}
                      </p>
                    </div>
                  </div>

                  <span className="absolute left-1/2 top-8 hidden h-4 w-4 -translate-x-1/2 rounded-full border-4 border-background-50 bg-accent-500 lg:block"></span>

                  <div className="hidden lg:block lg:w-1/2"></div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}